import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import _ from 'lodash'

import EtiquetaInscricaoReport from 'entity/Inscricao/Relatorios/EtiquetaInscricaoReport'
import { Button, Typography } from '@mui/material'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import DefaultCrudForm from 'components/form/DefaultCrudForm'

import { useIsAdmin, useUserUid } from 'useAuth'
import Rodada from 'entity/Rodada'


function EtiquetaAvulsaInter(props) {
    // const { showWarning } = useNotification()

    const [rodada, setRodada] = useState()

    const isAdmin = useIsAdmin()

    const currentUserUID = useUserUid()

    const imprimirEtiqueta = () => {

        const participante = { rodada: props.searchRodada, empresa: props.values.empresa }
        new EtiquetaInscricaoReport(participante).generate({ onlyPrint: true });
    }

    const loadOptions = useCallback(async () => {
        let resultRodada = await Rodada.get(props.searchUid)
        setRodada(resultRodada.data)
    }, [props.searchUid]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    useEffect(() => {
        let observer = null

        if (props.searchUid) {
            observer = Rodada.collection.doc(props.searchUid).onSnapshot(props.searchUid, (snap) => { setRodada(snap.data()) })
        }
        return () => {
            if (observer) observer()
        }
    }, [props.searchUid])

    return (
        <FormContent sx={{ m: 1 }}>
            {props.searchRodada.nome
                ? (isAdmin)
                    || (
                        rodada
                        && rodada.perfisAutorizado
                        && Object.keys(rodada.perfisAutorizado).length
                        && _.get(rodada.perfisAutorizado, currentUserUID)
                    )
                    ? <>
                        <Typography variant="h6">{props.searchRodada.nome}</Typography>
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.nomeEmpresaCracha"
                            label="Nome da Empresa no Crachá"
                            required
                        />
                        <TextInput
                            sx={{ flex: 2 }}
                            name="empresa.funcionarios.nomeCracha"
                            label="Nome do Participante no Crachá"
                            required
                        />
                        <Button
                            onClick={imprimirEtiqueta}
                            disabled={props?.values?.empresa?.nomeEmpresaCracha && props?.values?.empresa?.funcionarios?.nomeCracha ? false : true}
                        >
                            Imprimir Etiqueta
                        </Button>
                    </>
                    : <Typography
                        sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                        variant="h6"
                    >
                        - SEM PERMISSÃO PARA ACESSAR ESSA RODADA -
                    </Typography>
                : <Typography
                    sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                    variant="h6"
                >
                    - NOME DA RODADA DO LINK NÃO ENCONTRADO -
                </Typography>
            }
        </FormContent>
    )
}

export default function EtiquetaAvulsa() {
    const [searchParams] = useSearchParams()
    const searchUid = searchParams.get("uid")
    const searchRodada = { nome: searchParams.get("rodada") }

    return (
        <DefaultCrudForm
            title={"Etiqueta Avulsa"}
            formActions={{ novoForm: true, salvarForm: false, sairForm: true }}
            backRoute={`painel-controle?rodada=${searchUid}`}
        >
            {(props) => {
                return <EtiquetaAvulsaInter searchRodada={searchRodada} searchUid={searchUid} {...props} />
            }}
        </DefaultCrudForm>
    )
}